import { isAxiosError } from 'axios';
import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { sitecoreAxios } from './core.axios.js';
import { buildUrl } from './util.build-url.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS
});
function getElementContent(portalId, elementId, options) {
  const url = buildUrl(
    `/api/v1/portals/${portalId}/contentElements/${elementId}`,
    options
  );
  return cache(!(options == null ? void 0 : options.disableCache) ? url : void 0, async () => {
    var _a;
    try {
      const response = await sitecoreAxios.get(url);
      return response.data;
    } catch (err) {
      if (isAxiosError(err) && ((_a = err.response) == null ? void 0 : _a.status) === 404) {
        return void 0;
      }
      throw err;
    }
  }).getStaleWhileRevalidate();
}

export { getElementContent };
//# sourceMappingURL=request.get-element-content.js.map
